(function(){
  if (window.__mtInit) return; window.__mtInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
  function initReveal(root){ root.querySelectorAll('.mt-reveal:not(.is-in)').forEach(function(el){ if (io && !reduce) io.observe(el); else el.classList.add('is-in'); }); }
  function initTilt(root){
    root.querySelectorAll('[data-mt-tilt]').forEach(function(stage){
      if (stage.dataset.mtReady) return; stage.dataset.mtReady = '1';
      var img = stage.querySelector('.mt-tilt-target');
      if (!img || reduce || !window.matchMedia('(hover: hover)').matches) return;
      stage.addEventListener('pointermove', function(e){
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'rotateY(' + (x * 14).toFixed(2) + 'deg) rotateX(' + (-y * 14).toFixed(2) + 'deg)';
        stage.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        stage.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      stage.addEventListener('pointerleave', function(){ img.style.transform = ''; });
    });
  }
  function initTabs(root){
    root.querySelectorAll('[data-mt-tabs]').forEach(function(w){
      if (w.dataset.mtReady) return; w.dataset.mtReady = '1';
      var btns = w.querySelectorAll('[data-mt-tab]');
      btns.forEach(function(b){
        b.addEventListener('click', function(){
          var i = b.dataset.mtTab;
          btns.forEach(function(x){ var on = x.dataset.mtTab === i; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          w.querySelectorAll('[data-mt-pane]').forEach(function(p){ p.classList.toggle('is-active', p.dataset.mtPane === i); });
          if (b.dataset.bg) w.style.setProperty('--mt-stage', b.dataset.bg);
        });
      });
    });
  }
  function initHotspots(root){
    root.querySelectorAll('.mt-hs-dot').forEach(function(d){
      if (d.dataset.mtReady) return; d.dataset.mtReady = '1';
      d.addEventListener('click', function(){
        var was = d.classList.contains('is-open');
        d.closest('.mt-hs').querySelectorAll('.mt-hs-dot').forEach(function(x){ x.classList.remove('is-open'); x.setAttribute('aria-expanded', 'false'); });
        if (!was){ d.classList.add('is-open'); d.setAttribute('aria-expanded', 'true'); }
      });
    });
  }
  function initFaq(root){
    root.querySelectorAll('.mt-faq-q').forEach(function(q){
      if (q.dataset.mtReady) return; q.dataset.mtReady = '1';
      q.addEventListener('click', function(){
        var it = q.closest('.mt-faq-item'); var open = !it.classList.contains('is-open');
        it.classList.toggle('is-open', open); q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function init(root){ root = root || document; initReveal(root); initTilt(root); initTabs(root); initHotspots(root); initFaq(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
